import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../../Layout/DocumentationSidebar";
import TopMenu from "../../TopMenu";
import TableDocument from "../../TableDocument";
import FilterModal from "../../../../Components/Common/FilterModal";
import { get } from "../../../../utils/api";
import { useUser } from "../../../../context/AuthContext";

const API_BASE = "/scope3/processingOfSoldProducts";

const formatQuantitySoldForDoc = (quantitySold) => {
  if (quantitySold == null) return "N/A";
  if (typeof quantitySold === "object") {
    const v =
      quantitySold.value !== undefined && quantitySold.value !== null
        ? quantitySold.value
        : "";
    const u = quantitySold.unit != null ? String(quantitySold.unit).trim() : "";
    const combined = `${v} ${u}`.trim();
    return combined || "N/A";
  }
  return String(quantitySold).trim() || "N/A";
};

const ProcessingOfSoldProductsDocuments = () => {
  const { user } = useUser();
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const columnWidth = user?.companyAdmin
    ? "10% 12% 14% 14% 14% 14% 14% 8%"
    : "11% 15% 15% 15% 15% 15% 8%";

  const [selectedFacility, setSelectedFacility] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [url, setUrl] = useState("road");
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  const [filter, setFilter] = useState({
    productName: [],
    productCategory: [],
    vendorName: [],
    locationOfProcessing: [],
  });

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
  };

  const handleToggle = (option, nextUrl) => {
    setSelectedOption(option);
    setUrl(nextUrl);
  };

  let filtersToApply = {};

  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page,
        facilityList: selectedFacility.join(","),
        limit: 10,
        search: searchQuery,
      }).toString();

      const response = await get(
        `${API_BASE}/documents?${queryParams}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}`
      );
      const raw = Array.isArray(response.data.data) ? response.data.data : [];
      setData(
        raw.map((row) => ({
          ...row,
          quantitySoldDisplay: formatQuantitySoldForDoc(row.quantitySold),
        })),
      );
      setTotalPages(response.data.totalPages);
      setPage(response.data.currentPage);
    } catch (error) {
      console.error("Error fetching processing of sold products documents:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, url, fromDate, toDate, selectedFacility, searchQuery]);

  // const fetchFilter = async () => {
  //   try {
  //     const response = await get(`${API_BASE}/filter`);
  //     const {
  //       productName,
  //       productCategory,
  //       vendorName,
  //       locationOfProcessing,
  //     } = response.data?.data || {};
  //     setFilter({
  //       productName: productName || [],
  //       productCategory: productCategory || [],
  //       vendorName: vendorName || [],
  //       locationOfProcessing: locationOfProcessing || [],
  //     });
  //   } catch (error) {
  //     console.error(
  //       "Error fetching processing of sold products document filters:",
  //       error
  //     );
  //   }
  // };

  // useEffect(() => {
  //   fetchFilter();
  // }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const heading = [
    { title: "Date", key: "createdAt" },
    user?.companyAdmin
      ? { title: "Facility", key: "facilityName" }
      : null,
      {title:"Sold Product Date", key: "soldProductDate"},
    { title: "Product Name", key: "productName" },
    { title: "Customer/Vendor Name", key: "vendorName" },
    { title: "Quantity Sold", key: "quantitySoldDisplay" },
    { title: "Location", key: "locationOfProcessing" },
    // { title: "Electricity (KWH)", key: "energyDisplay" },
  ].filter(Boolean);



  const toggleData = [];

  return (
    <MainDashboardLayout sidebar={<DocumentationSidebar />}>
      <TopMenu
        {...{
          setDrawerFilterOpen: setIsFilterModalOpen,
          selectedMonth,
          setSelectedMonth,
          selectedYear,
          setSelectedYear,
          selectedOption,
          handleToggle,
          filterApplied: isFiltersApplied,
          toggleData,
          fromDate,
          setFromDate,
          toDate,
          setToDate,
          selectedFacility,
          setSelectedFacility,
          searchQuery,
          setSearchQuery,
          fetchData,
        }}
        heading="Processing of Sold Products"
      />

      <TableDocument
        data={data}
        totalPages={totalPages}
        page={page}
        handleChangePage={handleChangePage}
        headers={heading}
        columnWidth={columnWidth}
      />

      {/* <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        filters={filterData}
        onFilterChange={handleFilterChange}
        title="Filter"
      /> */}
    </MainDashboardLayout>
  );
};

export default ProcessingOfSoldProductsDocuments;
